import {money, moneyToInt} from '../money.js';

const setFormStyles = () => {
/**
  Change wrapper style on focus
**/
  document.addEventListener('focusin', e => {
    if (!e.target?.parentNode) return;
    const wrapper = e.target.parentNode.closest('.input-wrapper');
    if (!wrapper) return;
    wrapper.classList.add('focused');
  });

/**
  Change wrapper style on blur
**/
  document.addEventListener('focusout', e => {
    const wrapper = e.target.parentNode.closest('.input-wrapper');
    if (!wrapper) return;
    wrapper.classList.remove('focused');
  });

/**
  Focus on input when click on label
**/
  document.addEventListener('click', e => {
    if (e.target?.tagName.toLowerCase() !== 'label') return;
    const label = e.target;
    if (!label.parentNode.closest('.input-wrapper')) return;
    if (label.previousElementSibling?.tagName.toLowerCase() !== 'input') return;
    label.previousElementSibling.focus();
  });

/**
  Set money format for money inputs and keep clean value in hidden input
**/
  document.addEventListener('input', e => {
    const input = e.target;
    const wrapper = input.parentNode.closest('.input-wrapper.input-money');
    if (!wrapper) return;
    const inputHidden = wrapper.querySelector('input[type="hidden"]');
    inputHidden.value = moneyToInt(input.value);
    input.value = inputHidden.value > 0 ? money(inputHidden.value) : null; //Keep input empty if value reaches 0
    const event = new CustomEvent('money-input-change');
    document.dispatchEvent(event);
  });

/**
  Initialize input range
**/
  document.querySelectorAll('.field input[type="range"').forEach(range => {
    const initialColor = getComputedStyle(range).accentColor;
    const initialBg = getComputedStyle(range).backgroundColor;

    setRangeTrackColors(range, initialColor, initialBg);
    range.addEventListener('input', () => {
      window.setTimeout(() => {
        const color = getComputedStyle(range).accentColor;
        setRangeTrackColors(range, color, initialBg);
      }, 50);
    });
  });

/**
  Reset input value
**/
  document.querySelectorAll('.js-clear-input').forEach(btn => {
    const wrapper = btn.closest('.input-wrapper');
    if (!wrapper) return;
    const input = wrapper.querySelector('input');
    if (!input) return;
    btn.addEventListener('click', () => input.value = '');
  });
};

/**
  Set input range track colors
**/
const setRangeTrackColors = (range, color, bg) => {
  const value = range.value;
  const completionPct = (value-range.min)/(range.max-range.min)*100;
  range.style.background = `linear-gradient(
    to right,
    ${color} 0%,
    ${color} ${completionPct}%,
    ${bg} ${completionPct}%,
    ${bg} 100%)`;
};

setFormStyles();

export {setRangeTrackColors};
